export default __webpack_public_path__ + "708629ff1e8cbdc0b4706b8ed50bbedb.svg";